import { Stack } from "@mui/material";
import BasicTooltip from "src/components/BasicTooltip";
import Iconify from "src/components/Iconify";

// ----------------------------------------------------------------------
type Props = {
	ownersNames: string;
	portfolio: string;
};

export const TooltipIcons = ({ portfolio, ownersNames }: Props) => {
	return (
		<Stack gap={1.5} flexDirection={"row"} alignItems={"center"} sx={{ mt: 0.2 }}>
			<BasicTooltip title={ownersNames}>
				<Iconify icon={"mdi:users"} color={"text.secondary"} width={13} />
			</BasicTooltip>
			<BasicTooltip title={portfolio}>
				<Iconify icon={"ion:wallet"} width={13} color={"text.secondary"} />
			</BasicTooltip>
		</Stack>
	);
};

export default TooltipIcons;
